module.exports = __webpack_public_path__ + "static/memoji-item-1-b6a80b657c2eb80d4deb17f6a78a8b59.png";